import axios from 'axios'
import qs from 'qs'
import FileSaver from 'file-saver'
import fn from '../../utils/functions'
import dayjs from 'dayjs';

// Normaliza fechas en profundidad para evitar que qs.stringify destruya objetos Dayjs
export function convertDates(obj) {
  if (obj == null) return obj;

  // Detecta Day.js correctamente
  if (dayjs.isDayjs(obj)) {
    return obj.toISOString();
  }

  // Detecta Date nativo
  if (obj instanceof Date) {
    return obj.toISOString();
  }

  // Arrays → recorrer
  if (Array.isArray(obj)) {
    return obj.map(item => convertDates(item));
  }

  // Objetos → recorrer recursivamente
  if (typeof obj === 'object') {
    const newObj = {};
    for (const key in obj) {
      newObj[key] = convertDates(obj[key]);
    }
    return newObj;
  }

  
  return obj;
}

// Estado inicial solo para salesReport y filtros principales
function initSession () {
  const session = {
    salesReport: {
      tableData: [],
      totalSalesReport: 0
    },
    querySalesReport: {
      page: 0,
      size: 20,
      sort: 'creationDateTime,DESC',
      creationDateTimeFrom: fn.initDateFrom(3),
      creationDateTimeTo: fn.initDateTo()
    },
    listSelectedFiltersSalesReport: [],
    // combos principales
    optionsFilterServiceSalesReport: [],
    optionsFilterSellerCompanySalesReport: [],
    optionsFilterBuyerCompanySalesReport: [],
    optionsFilterPointOfSaleSalesReport: [],
    optionsFilterDocumentNumberSalesReport: [],
    optionsFilterSaleDateSalesReport: [],
    optionsFilterArticleCodeSalesReport: []
  }
  return session
}

function initLocal () {
  const local = {
    isShowServiceSalesReport: true,
    isShowSellerCompanySalesReport: true,
    isShowBuyerCompanySalesReport: true,
    isShowPointOfSaleSalesReport: true,
    isShowDocumentNumberSalesReport: true,
    isShowDocumentDateSalesReport: true,
    isShowSaleDateSalesReport: true,
    isShowArticleCodeSalesReport: true,
    isShowQuantitySoldSalesReport: true,
    isShowQuantityReturnedSalesReport: true,
    isShowCreationDateTimeSalesReport: true
  }
  return local
}

function setByUserLocalSalesReport () {
  if (JSON.parse(localStorage.getItem(state.userConfigLocalStorage))?.salesReport) {
    const local = JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).salesReport
    return local
  } else {
    return initLocal()
  }
}

// state
const state = {
  userConfigLocalStorage: '',
  local: initLocal(),
  session: initSession()
}

// getters
const getters = {
  salesReport: state => state.session.salesReport,
  querySalesReport: state => state.session.querySalesReport,
  listSelectedFiltersSalesReport: state => state.session.listSelectedFiltersSalesReport,
  // combos
  optionsFilterServiceSalesReport: state => state.session.optionsFilterServiceSalesReport,
  optionsFilterSellerCompanySalesReport: state => state.session.optionsFilterSellerCompanySalesReport,
  optionsFilterBuyerCompanySalesReport: state => state.session.optionsFilterBuyerCompanySalesReport,
  optionsFilterPointOfSaleSalesReport: state => state.session.optionsFilterPointOfSaleSalesReport,
  optionsFilterDocumentNumberSalesReport: state => state.session.optionsFilterDocumentNumberSalesReport,
  optionsFilterSaleDateSalesReport: state => state.session.optionsFilterSaleDateSalesReport,
  optionsFilterArticleCodeSalesReport: state => state.session.optionsFilterArticleCodeSalesReport,
  // columnas tabla
  isShowServiceSalesReport: state => state.local.isShowServiceSalesReport,
  isShowSellerCompanySalesReport: state => state.local.isShowSellerCompanySalesReport,
  isShowBuyerCompanySalesReport: state => state.local.isShowBuyerCompanySalesReport,
  isShowPointOfSaleSalesReport: state => state.local.isShowPointOfSaleSalesReport,
  isShowDocumentNumberSalesReport: state => state.local.isShowDocumentNumberSalesReport,
  isShowDocumentDateSalesReport: state => state.local.isShowDocumentDateSalesReport,
  isShowSaleDateSalesReport: state => state.local.isShowSaleDateSalesReport,
  isShowArticleCodeSalesReport: state => state.local.isShowArticleCodeSalesReport,
  isShowQuantitySoldSalesReport: state => state.local.isShowQuantitySoldSalesReport,
  isShowQuantityReturnedSalesReport: state => state.local.isShowQuantityReturnedSalesReport,
  isShowCreationDateTimeSalesReport: state => state.local.isShowCreationDateTimeSalesReport
}

// actions
const actions = {
  setUserNameSalesReport ({ state }) {
    const B2bUserConfigSession = JSON.parse(sessionStorage.getItem('store'))
    state.userConfigLocalStorage = B2bUserConfigSession.activeUser.data.username
    if (JSON.parse(localStorage.getItem(state.userConfigLocalStorage))) {
      state.local = setByUserLocalSalesReport()
    }
  },

  async getSalesReports ({ commit }, data) {
    try {
      // Solo enviar los parámetros activos del filtro
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/salesreport',
        params: {
          ...data.query
        },
        headers: { 'Accept-Language': data.activeLang },
        paramsSerializer: params => {
          return qs.stringify(convertDates(params), { indices: false })
        }
      })
      commit('SALESREPORT_STATE', {
        tableData: response.data.content,
        totalSalesReport: response.data.totalElements
      })
      return response.data
    } catch (error) {
      throw error.response
    }
  },

  // Servicio para descargar sales report en formato CSV
  async downloadSalesReportCsv ({ commit, rootState }, params) {
    try {
      // Enviar solo los parámetros activos, sin limpiar ni borrar nada
      params.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
          rootState.session.urlIn !== 'b2b') {
        params.urlName = rootState.session.urlIn
      }
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/salesreport/csv',
        params: params,
        responseType: 'blob',
        headers: { 'Accept-Language': params.activeLang },
        paramsSerializer: params => {
          return qs.stringify(convertDates(params), { indices: false })
        }
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'salesreport.csv'
      const fileGroup = /([^;]+;_+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup?.[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      throw error.response
    }
  },

  // Servicio para descargar sales report en formato original (ej: XML, PDF, etc)
  async downloadSalesReportOriginal({ commit, rootState }, params) {
    try {
      params.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
          rootState.session.urlIn !== 'b2b') {
        params.urlName = rootState.session.urlIn
      }
      if (params.salesReportsId && Array.isArray(params.salesReportsId)) {
        params.salesReportsId = [params.salesReportId[0]]
      }
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/salesreport/original',
        params: params,
        responseType: 'blob',
        headers: { 'Accept-Language': params.activeLang },
        paramsSerializer: params => {
          return qs.stringify(convertDates(params), { indices: false })
        }
      })
      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'salesreport-original.zip'
      const fileGroup = /([^;]+;_+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup?.[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      throw error.response
    }
  },

  // Servicio para descargar metadata del sales report
  async downloadSalesReportMetadata({ commit, rootState }, params) {
    try {
      params.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
          rootState.session.urlIn !== 'b2b') {
        params.urlName = rootState.session.urlIn
      }
      if (params.salesReportsId && Array.isArray(params.salesReportsId)) {
        params.salesReportsId = [params.salesReportsId[0]]
      }
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/salesreport/metadata',
        params: params,
        responseType: 'blob',
        headers: { 'Accept-Language': params.activeLang },
        paramsSerializer: params => {
          return qs.stringify(convertDates(params), { indices: false })
        }
      })
      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'salesreport-metadata.zip'
      const fileGroup = /([^;]+;_+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup?.[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      throw error.response
    }
  },

  // Métodos para limpiar y actualizar filtros activos
  async listSelectedFiltersSalesReportState({ commit }, payload) {
    commit('LIST_SELECTED_FILTERS_SALESREPORT_STATE', payload)
  },
  async querySalesReportState({ commit }, payload) {
    commit('QUERY_SALESREPORT_STATE', payload)
  },
  async salesReportState({ commit }, payload) {
    commit('SALESREPORT_STATE', payload)
  },

  // Métodos para columnas visibles
  isShowServiceSalesReportAction: ({ commit }, payload) => {
    commit('IS_SHOW_SERVICE_SALESREPORT', payload)
  },
  isShowSellerCompanySalesReportAction: ({ commit }, payload) => {
    commit('IS_SHOW_SELLER_COMPANY_SALESREPORT', payload)
  },
  isShowBuyerCompanySalesReportAction: ({ commit }, payload) => {
    commit('IS_SHOW_BUYER_COMPANY_SALESREPORT', payload)
  },
  isShowPointOfSaleSalesReportAction: ({ commit }, payload) => {
    commit('IS_SHOW_POINT_OF_SALE_SALESREPORT', payload)
  },
  isShowDocumentNumberSalesReportAction: ({ commit }, payload) => {
    commit('IS_SHOW_DOCUMENT_NUMBER_SALESREPORT', payload)
  },
  isShowDocumentDateSalesReportAction: ({ commit }, payload) => {
    commit('IS_SHOW_DOCUMENT_DATE_SALESREPORT', payload)
  },
  isShowSaleDateSalesReportAction: ({ commit }, payload) => {
    commit('IS_SHOW_SALE_DATE_SALESREPORT', payload)
  },
  isShowArticleCodeSalesReportAction: ({ commit }, payload) => {
    commit('IS_SHOW_ARTICLE_CODE_SALESREPORT', payload)
  },
  isShowQuantitySoldSalesReportAction: ({ commit }, payload) => {
    commit('IS_SHOW_QUANTITY_SOLD_SALESREPORT', payload)
  },
  isShowQuantityReturnedSalesReportAction: ({ commit }, payload) => {
    commit('IS_SHOW_QUANTITY_RETURNED_SALESREPORT', payload)
  },
  isShowCreationDateTimeSalesReportAction: ({ commit }, payload) => {
    commit('IS_SHOW_CREATION_DATE_TIME_SALESREPORT', payload)
  }
}

// mutations
const mutations = {
  resetSessionSalesReport (state) {
    state.session = initSession()
    state.local = initLocal()
  },
  'SALESREPORT_STATE' (state, payload) {
    state.session.salesReport = payload
  },
  'QUERY_SALESREPORT_STATE' (state, payload) {
    state.session.querySalesReport = payload
  },
  'LIST_SELECTED_FILTERS_SALESREPORT_STATE' (state, payload) {
    state.session.listSelectedFiltersSalesReport = payload
  },
  // combos
  'OPTIONS_FILTER_SERVICE_SALESREPORT' (state, payload) {
    state.session.optionsFilterServiceSalesReport = payload
  },
  'OPTIONS_FILTER_SELLER_COMPANY_SALESREPORT' (state, payload) {
    state.session.optionsFilterSellerCompanySalesReport = payload
  },
  'OPTIONS_FILTER_BUYER_COMPANY_SALESREPORT' (state, payload) {
    state.session.optionsFilterBuyerCompanySalesReport = payload
  },
  'OPTIONS_FILTER_POINT_OF_SALE_SALESREPORT' (state, payload) {
    state.session.optionsFilterPointOfSaleSalesReport = payload
  },
  'OPTIONS_FILTER_DOCUMENT_NUMBER_SALESREPORT' (state, payload) {
    state.session.optionsFilterDocumentNumberSalesReport = payload
  },
  'OPTIONS_FILTER_SALE_DATE_SALESREPORT' (state, payload) {
    state.session.optionsFilterSaleDateSalesReport = payload
  },
  'OPTIONS_FILTER_ARTICLE_CODE_SALESREPORT' (state, payload) {
    state.session.optionsFilterArticleCodeSalesReport = payload
  },
  // columnas tabla
  'IS_SHOW_SERVICE_SALESREPORT' (state, payload) {
    state.local.isShowServiceSalesReport = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    if (!storeuser.salesReport) storeuser.salesReport = {}
    storeuser.salesReport.isShowServiceSalesReport = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SELLER_COMPANY_SALESREPORT' (state, payload) {
    state.local.isShowSellerCompanySalesReport = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    if (!storeuser.salesReport) storeuser.salesReport = {}
    storeuser.salesReport.isShowSellerCompanySalesReport = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_BUYER_COMPANY_SALESREPORT' (state, payload) {
    state.local.isShowBuyerCompanySalesReport = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    if (!storeuser.salesReport) storeuser.salesReport = {}
    storeuser.salesReport.isShowBuyerCompanySalesReport = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_POINT_OF_SALE_SALESREPORT' (state, payload) {
    state.local.isShowPointOfSaleSalesReport = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    if (!storeuser.salesReport) storeuser.salesReport = {}
    storeuser.salesReport.isShowPointOfSaleSalesReport = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DOCUMENT_NUMBER_SALESREPORT' (state, payload) {
    state.local.isShowDocumentNumberSalesReport = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    if (!storeuser.salesReport) storeuser.salesReport = {}
    storeuser.salesReport.isShowDocumentNumberSalesReport = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DOCUMENT_DATE_SALESREPORT' (state, payload) {
    state.local.isShowDocumentDateSalesReport = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    if (!storeuser.salesReport) storeuser.salesReport = {}
    storeuser.salesReport.isShowDocumentDateSalesReport = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SALE_DATE_SALESREPORT' (state, payload) {
    state.local.isShowSaleDateSalesReport = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    if (!storeuser.salesReport) storeuser.salesReport = {}
    storeuser.salesReport.isShowSaleDateSalesReport = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ARTICLE_CODE_SALESREPORT' (state, payload) {
    state.local.isShowArticleCodeSalesReport = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    if (!storeuser.salesReport) storeuser.salesReport = {}
    storeuser.salesReport.isShowArticleCodeSalesReport = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_QUANTITY_SOLD_SALESREPORT' (state, payload) {
    state.local.isShowQuantitySoldSalesReport = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    if (!storeuser.salesReport) storeuser.salesReport = {}
    storeuser.salesReport.isShowQuantitySoldSalesReport = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_QUANTITY_RETURNED_SALESREPORT' (state, payload) {
    state.local.isShowQuantityReturnedSalesReport = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    if (!storeuser.salesReport) storeuser.salesReport = {}
    storeuser.salesReport.isShowQuantityReturnedSalesReport = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CREATION_DATE_TIME_SALESREPORT' (state, payload) {
    state.local.isShowCreationDateTimeSalesReport = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    if (!storeuser.salesReport) storeuser.salesReport = {}
    storeuser.salesReport.isShowCreationDateTimeSalesReport = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
